import React, {Component, ReactElement, ReactNode, RefObject} from 'react'

import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {Messages} from '../../../Messages'
import {MESSAGE_TYPE, ROLE_FOR_ADMINISTRATOR, THREAD_CATEGORY, THREAD_PRIORITY} from '../../../CodeMaster'
import {StyledDiv, StyledLabel} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {HKConstants} from '../../../HKConstants'
import PPSelect from '../../../components/shared/forms/PPSelect'
import {addEmptyData, isNoSelect} from '../../../componentHelper/selectHelper'
import PPRadioGroup from '../../../components/shared/forms/PPRadioGroup'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import PPImageInputWithPreview, {ImageInformation} from '../../../components/shared/forms/PPImageInputWithPreview'
import {FlexStartRowFlexContainer, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPInput from '../../../components/shared/forms/PPInput'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import {
    NatPostBulletinBoardThread,
    NatPostBulletinBoardThreadParams,
    ThreadFile,
    ThreadImage,
} from './repository/NatPostBulletinBoardThread'
import {
    downloadDataUriSchemeOnMsSaveBlob,
    getFileExtension,
    getFileIconPath,
    openPdfPreviewWindow,
} from '../../common/util/Natutil'
import PPFileInput from '../../../components/shared/forms/PPFileInput'
import {isEdge, isIE} from 'react-device-detect'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_LOGIN_USER_FAMILY_NAME: string = 'loginUserAdminFamilyName'
const KEY_LOGIN_USER_FIRST_NAME: string = 'loginUserAdminFirstName'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'
const KEY_LOGIN_USER_ROLE_NAME: string = 'loginUserRoleName'

interface Props {
    bulletinBoardRepo: NatBulletinBoardRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    isLoadCompleted: boolean
    threadInfoCategory: string
    threadInfoPriority: string
    threadInfoTitle: string
    threadInfoDetail: string
    threadInfoFiles: ThreadFile[]
    threadInfoImages: ImageInformation[]
    publishFileName: string
    addFileButtonDisabled: boolean
    fileName: string
    fileData: string | ArrayBuffer | null
    fileSize: number
    fileInputDisabled: boolean

}


class NatAdminBulletinBoardThreadRegisterPage extends Component<Props & AdminPagePropsSet, States> {

    threadFile: RefObject<HTMLInputElement>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            isLoadCompleted: false,
            threadInfoCategory: '',
            threadInfoPriority: THREAD_PRIORITY.NORMAL.value,
            threadInfoTitle: '',
            threadInfoDetail: '',
            threadInfoFiles: [],
            threadInfoImages: [],
            publishFileName: '',
            fileName: '',
            fileData: '',
            fileSize: 0,
            addFileButtonDisabled: true,
            fileInputDisabled: false,
        }

        this.threadFile = React.createRef()

        this.threadRegisterClickButton = this.threadRegisterClickButton.bind(this)
        this.clickCancelButton = this.clickCancelButton.bind(this)
        this.clickOkButton = this.clickOkButton.bind(this)
        this.backThreadList = this.backThreadList.bind(this)
        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.onChangePriority = this.onChangePriority.bind(this)
        this.onChangeTitle = this.onChangeTitle.bind(this)
        this.onChangeDetail = this.onChangeDetail.bind(this)
        this.onChangeImages = this.onChangeImages.bind(this)
        this.onChangeFile = this.onChangeFile.bind(this)
        this.onChangePublishFileName = this.onChangePublishFileName.bind(this)
        this.judgeRegisterButtonDisabled = this.judgeRegisterButtonDisabled.bind(this)
        this.changeThreadFileSortOrder = this.changeThreadFileSortOrder.bind(this)
        this.deleteThreadFile = this.deleteThreadFile.bind(this)
        this.validThreadInfoFileCount = this.validThreadInfoFileCount.bind(this)

    }

    async componentDidMount(): Promise<void> {
        this.setState({isLoadCompleted: true})
    }


    // 登録するボタン押下
    async threadRegisterClickButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('スレッド'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.clickCancelButton,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.clickOkButton,
                    },
                ],
            },
        )
    }

    previewThreadFile(dataUri: string): void {
        const data: string[] = dataUri.split(',')
        if (data[1]) {
            openPdfPreviewWindow(data[1])
        }
    }

    clickCancelButton(): void {
        this.props.eventEmitter.closeDialog()
    }

    async clickOkButton(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {

            const threadInfoImages: ThreadImage[] = []
            if (this.state.threadInfoImages.length > 0) {
                this.state.threadInfoImages.map(
                    (image, index) => {
                        if (image.name && image.base64data && image.size) {
                            threadInfoImages.push({
                                fileName: image.name,
                                fileData: image.base64data,
                                fileSize: image.size,
                            })
                        }
                    },
                )
            }

            const threadInfoFiles: ThreadFile[] = []
            if (this.state.threadInfoFiles) {
                this.state.threadInfoFiles.forEach((file, index) => {
                    if (file.deleteFlag === true) {
                        return
                    }
                    if (file.fileData) {
                        const fileData: string[] = String(file.fileData).split(',')
                        if (fileData[1]) {
                            threadInfoFiles.push({
                                sortOrder: file.sortOrder,
                                publishFileName: file.publishFileName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            })
                        }
                    }
                })
            }

            const postBulletinBoardThreadParams: NatPostBulletinBoardThreadParams = {
                categoryId: this.state.threadInfoCategory,
                priority: this.state.threadInfoPriority,
                title: this.state.threadInfoTitle,
                detail: this.state.threadInfoDetail,
                threadImage: threadInfoImages,
                threadFile: threadInfoFiles,
            }


            const postBulletinBoardThreadResult: Nullable<NatPostBulletinBoardThread> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.postBulletinBoardThread.bind(
                        this.props.bulletinBoardRepo, postBulletinBoardThreadParams),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('スレッド')},
                )
            if (postBulletinBoardThreadResult &&
                postBulletinBoardThreadResult.details &&
                postBulletinBoardThreadResult.requestError === null
            ) {
                this.props.navigate(`/admin/bulletinBoardThread/${postBulletinBoardThreadResult.details.threadId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0004.toString('スレッド', this.state.threadInfoTitle),
                            },
                        },
                    },
                )
            }


        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    backThreadList(): void {
        this.props.navigate(
            `/admin/bulletinBoardThreadList`,
        )
    }

    onChangeCategory(event: SelectChangeEvent<unknown>): void {
        const categoryId: string = `${event.target.value}`
        this.setState({threadInfoCategory: isNoSelect(categoryId) ? '' : categoryId})
    }

    onChangePriority(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({threadInfoPriority: event.target.value})
    }

    onChangeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({threadInfoTitle: event.target.value})
    }

    onChangeDetail(value: string): void {
        this.setState({threadInfoDetail: value})
    }

    onChangeImages(images: ImageInformation[]): void {
        this.setState({threadInfoImages: images})
    }

    onChangePublishFileName(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value && this.state.fileName) {
            this.setState({addFileButtonDisabled: false})
        } else {
            this.setState({addFileButtonDisabled: true})
        }
        this.setState({publishFileName: event.target.value})
    }

    validThreadInfoFileCount(): number {
        const threadInfoFiles = this.state.threadInfoFiles
        const validThreadInfoFileCount = threadInfoFiles.filter(file => file.deleteFlag === false).length
        return validThreadInfoFileCount
    }

    addThreadFile(): void {
        const threadFileList = this.state.threadInfoFiles
        const validThreadFileList = threadFileList.filter(file => file.deleteFlag === false)
        const threadFile: ThreadFile = {
            ['sortOrder']: validThreadFileList.length + 1,
            ['fileName']: this.state.fileName,
            ['fileSize']: this.state.fileSize,
            ['fileData']: this.state.fileData,
            ['publishFileName']: this.state.publishFileName,
            ['deleteFlag']: false,
        }
        threadFileList.push(threadFile)
        this.setState({
            fileName: '',
            fileSize: 0,
            fileData: '',
            publishFileName: '',
            addFileButtonDisabled: true,
            threadInfoFiles: threadFileList,
            fileInputDisabled: (validThreadFileList.length + 1 >= 3),
        })
        // 追加したタイミングで選択したファイルをクリア
        if (this.threadFile.current && this.threadFile.current.value) {
            this.threadFile.current.value = ''
        }
    }

    onChangeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            if (this.state.publishFileName) {
                this.setState({addFileButtonDisabled: false})
            } else {
                this.setState({addFileButtonDisabled: true})
            }
            this.setState({
                fileName: event.target.files[0].name,
                fileSize: event.target.files[0].size,
            })
            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({fileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        } else {
            this.setState({
                fileName: '',
                fileData: '',
                fileSize: 0,
                addFileButtonDisabled: true,
            })
        }
    }

    changeThreadFileSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        const threadInfoFiles = this.state.threadInfoFiles
        threadInfoFiles[Number(event.target.name)].sortOrder = Number(event.target.value)
        this.setState({threadInfoFiles: threadInfoFiles})
    }

    deleteThreadFile(index: number): void {
        const threadInfoFiles = this.state.threadInfoFiles
        threadInfoFiles[index].deleteFlag = true
        threadInfoFiles[index].fileData = null
        const addFileCount = threadInfoFiles.filter(file => file.deleteFlag === false)
        this.setState({
            threadInfoFiles: threadInfoFiles,
            fileInputDisabled: (addFileCount.length >= 3),
        })
    }

    judgeRegisterButtonDisabled(): boolean {
        return !(this.state.threadInfoTitle &&
            this.state.threadInfoCategory &&
            this.state.threadInfoPriority &&
            this.state.threadInfoDetail)
    }

    getFileLink(threadFile: ThreadFile): ReactElement {
        switch (getFileExtension(threadFile.fileName).toUpperCase()) {
            case 'PDF':
                return (
                    <a href="javascript:void(0)" target={'_blank'}
                       onClick={(event: React.MouseEvent<HTMLElement>) => {
                           event.preventDefault()
                           this.previewThreadFile(threadFile.fileData as string)
                       }}>
                        <img
                            src={getFileIconPath(getFileExtension(threadFile.fileName))}
                            alt={threadFile.fileName}/>
                    </a>
                )
                break

            default:
                if (isIE || isEdge) {
                    return (
                        <a href="javascript:void(0)"
                           onClick={() => downloadDataUriSchemeOnMsSaveBlob(String(threadFile.fileData),
                               `${threadFile.publishFileName}.${getFileExtension(threadFile.fileName)}`)}>
                            <img src={getFileIconPath(getFileExtension(threadFile.fileName))}
                                 alt={threadFile.fileName}/>
                        </a>
                    )
                } else {
                    return (
                        <a href={String(threadFile.fileData)}
                           download={`${threadFile.publishFileName}.${getFileExtension(threadFile.fileName)}`}>
                            <img src={getFileIconPath(getFileExtension(threadFile.fileName))}
                                 alt={threadFile.fileName}/>
                        </a>
                    )
                }
                break
        }
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgeRegisterButtonDisabled()}
                        onClick={this.threadRegisterClickButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backThreadList}
                    >
                        スレッド検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderThreadFormTable(): ReactNode {

        const assocFlag: boolean =
            SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID) === ROLE_FOR_ADMINISTRATOR.ASSOC.value
        const loginUserRoleName: string =
            SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_ROLE_NAME, '')
        const loginUserAdminFamilyName: string =
            SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_FAMILY_NAME, '')
        const loginUserAdminFirstName: string =
            SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_FIRST_NAME, '')

        return (
            <Table>
                <StyledTableCaption>スレッド情報</StyledTableCaption>
                <StyledTableDiscription>
                    {Messages.INTFC0001.toString(HKConstants.VMN.NTF.THREAD_RETENTION_YEAR)}
                </StyledTableDiscription>
                <TableBody>
                    <TableRow>
                        <TableRowName required>カテゴリー</TableRowName>
                        <TableCell>
                            <PPSelect
                                data={addEmptyData(THREAD_CATEGORY.values(), 'カテゴリを選択してください')}
                                onChange={this.onChangeCategory}
                                value={this.state.threadInfoCategory}
                                eventKeys={['categoryId']}
                                eventEmitter={this.props.eventEmitter}
                                autoFocus
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>優先度</TableRowName>
                        <TableCell>
                            <PPRadioGroup
                                row
                                data={THREAD_PRIORITY.values()}
                                value={this.state.threadInfoPriority}
                                onChange={this.onChangePriority}
                                eventKeys={['priority']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>タイトル</TableRowName>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                required
                                fullWidth
                                value={this.state.threadInfoTitle}
                                onChange={this.onChangeTitle}
                                eventKeys={['title']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>投稿者</TableRowName>
                        <TableCell>
                            {`${loginUserAdminFamilyName} ${loginUserAdminFirstName}`}
                            {!assocFlag &&
                                `　${Messages.INTFA0028.toString(loginUserRoleName)}`
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>詳細</TableRowName>
                        <TableCell>
                            <PPHtmlEditor
                                onEditorChange={this.onChangeDetail}
                                eventKeys={['detail']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>画像</TableRowName>
                        <TableCell>
                            <PPImageInputWithPreview
                                images={this.state.threadInfoImages}
                                maxCount={4}
                                maxFileSizeBytesPerFile={5 * 1024 * 1024}
                                maxFileSizeBytesPerFileMessage={
                                    'アップロードファイルの上限サイズは1ファイルあたり5MBまでです'
                                }
                                helperText={<div style={{color: 'red'}}>
                                    ※5MBまで
                                </div>}
                                eventEmitter={this.props.eventEmitter}
                                inputProps={{
                                    accept: 'image/jpeg,image/png,image/gif',
                                }}
                                eventKeys={['threadImage']}
                                onChange={this.onChangeImages}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName
                            {...{
                                rowSpan: this.validThreadInfoFileCount() !== 0 ?
                                    this.validThreadInfoFileCount() + 1 : 1,
                            }}
                        >ファイル</TableRowName>
                        <TableCell colSpan={4}>
                            <FlexStartRowFlexContainer>
                                <DocumentNameWrapper>
                                    <TableCellLabelNoLeftPadding>ファイル名</TableCellLabelNoLeftPadding>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                id: 'onChangePublishFileName',
                                                maxLength: 50,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onChange={this.onChangePublishFileName}
                                        eventKeys={['publishMaterialInfo']}
                                        value={this.state.publishFileName}
                                        eventEmitter={this.props.eventEmitter}
                                        disabled={this.state.fileInputDisabled}
                                    />
                                </DocumentNameWrapper>
                                <DocumentWrapper>
                                    <DocumentFormWrapper>
                                        <PPFileInput
                                            InputProps={{
                                                inputProps: {
                                                    id: 'messageFile',
                                                    name: 'messageFile',
                                                },
                                            }}
                                            fullWidth
                                            inputRef={this.threadFile}
                                            onChange={this.onChangeFile}
                                            fileName={this.state.fileName}
                                            eventKeys={['threadFile']}
                                            eventEmitter={this.props.eventEmitter}
                                            disabled={this.state.fileInputDisabled}
                                        />
                                    </DocumentFormWrapper>
                                    <div style={{color: 'red', flex: '1 0 auto'}}>
                                        ※5MBまで<br/>※特定のファイル形式(.docx/.xlsx/.pptx/.pdf)以外は、<br/>{'　'}アップロード出来ません。
                                    </div>
                                </DocumentWrapper>
                                <DocumentAddButtonWrapper>
                                    <AdminPrimaryButton
                                        onClick={this.addThreadFile.bind(this)}
                                        disabled={this.state.addFileButtonDisabled || this.state.fileInputDisabled}>
                                        ファイルを追加
                                    </AdminPrimaryButton>
                                </DocumentAddButtonWrapper>
                            </FlexStartRowFlexContainer>
                        </TableCell>
                    </TableRow>
                    {this.renderFileArea()}
                </TableBody>
            </Table>
        )
    }

    renderFileArea(): ReactNode {
        return (
            <>
                {this.state.threadInfoFiles.map((threadFile, index) => (
                    (threadFile.deleteFlag === false) ?
                        <TableRow key={index}>
                            <TableCell colSpan={3}>
                                <RowFlexContainer>
                                    <AlreadyDocumentWrapper>
                                        <TableCellLabelNoLeftPadding>
                                            {this.getFileLink(threadFile)}
                                        </TableCellLabelNoLeftPadding>
                                        <PPInput
                                            type="label"
                                            value={threadFile.publishFileName}
                                            eventKeys={[`threadFile[${index}].publishFileName`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        並び順
                                    </TableCellLabelNoLeftPadding>
                                    <OrderWrapper>
                                        <DocumentFormWrapper>
                                            <PPNumericField
                                                InputProps={{
                                                    inputProps: {
                                                        min: 1,
                                                        max: 999,
                                                    },
                                                }}
                                                fullWidth
                                                name={String(index)}
                                                onChange={this.changeThreadFileSortOrder.bind(this)}
                                                value={threadFile.sortOrder}
                                                eventKeys={[`threadFile[${index}].sortOrder`]}
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                        </DocumentFormWrapper>
                                    </OrderWrapper>
                                    <AlreadyDocumentWrapper>
                                        <TableCellLabelNoLeftPadding>
                                            <StyledLink onClick={() => this.deleteThreadFile(index)}>
                                                削除
                                            </StyledLink>
                                        </TableCellLabelNoLeftPadding>
                                    </AlreadyDocumentWrapper>
                                </RowFlexContainer>
                            </TableCell>
                        </TableRow>
                        : null
                ))}

            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderThreadFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }

}

const DocumentNameWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  padding-right: 15px;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
  padding: 0 10px 0 0;
`


const DocumentWrapper = styled(DocumentNameWrapper)`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 15px;
  max-width: 40%;
`

const DocumentFormWrapper: StyledDiv = styled.div`
  flex: 1 0 auto;
  width: 100%;
`

const DocumentAddButtonWrapper: StyledDiv = styled.div`
  flex: 0 0 auto;
`

const AlreadyDocumentWrapper = styled(DocumentNameWrapper)`
  flex: 1 1 0%;
  align-items: center;
`

const OrderWrapper = styled(AlreadyDocumentWrapper)`
  max-width: 10%;
`

const StyledTableDiscription = styled(StyledTableCaption)`
  background-color: transparent !important;
  font-size: 0.875rem !important;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
`


export default createAdminPage(NatAdminBulletinBoardThreadRegisterPage)

